var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMeal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "-5 -5 21 21",
    preserveAspectRatio: "xMidYMin slice",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "173CD089-BB40-465F-9D94-D8E5FE174F3D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-263.000000, -463.000000)",
    fill: "#0B2730",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.755973,463.25237 C273.430603,462.927 272.905006,462.927 272.579636,463.25237 L268.5,467.323663 L264.420364,463.244027 C264.094994,462.918658 263.569397,462.918658 263.244027,463.244027 C262.918658,463.569397 262.918658,464.094994 263.244027,464.420364 L267.323663,468.5 L263.244027,472.579636 C262.918658,472.905006 262.918658,473.430603 263.244027,473.755973 C263.569397,474.081342 264.094994,474.081342 264.420364,473.755973 L268.5,469.676337 L272.579636,473.755973 C272.905006,474.081342 273.430603,474.081342 273.755973,473.755973 C274.081342,473.430603 274.081342,472.905006 273.755973,472.579636 L269.676337,468.5 L273.755973,464.420364 C274.073,464.103337 274.073,463.569397 273.755973,463.25237 Z",
    id: "geenmaaltijd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMeal);
export default __webpack_public_path__ + "static/media/no_meal.e02f8cf720b02631f5f340771983acc3.svg";
export { ForwardRef as ReactComponent };